import React from "react";

import logger from "../../../../../utils/LoggerFrontend";
import { Skeleton } from "../../Components";
import { useTranslation } from "react-i18next";

import {
  PostEditorSkeletonWrapper,
  MobileTop,
  MobileSide,
  SkeletonEditorWrapper,
  SkeletonEditor,
  Header,
  PageHeaderWrapper,
  PageName,
  SponsoredMessage,
  EditorWrapper,
  PhotoEditorWrapper,
  FooterWrapper,
  FooterTextSections,
  SKELETON_IMAGE_SIZE_SPEC
} from "./PostEditorSkeleton.styled";

export const PageHeader = ({ campaignLanguage }) => {
  const { t } = useTranslation();

  logger.debug("PostEditorSkeleton:PageHeader:render", "renders");

  return (
    <PageHeaderWrapper>
      <Skeleton width="40px" height="40px" borderRadius="100%" margin="0 12px 0 0" />
      <div>
        <PageName>
          <Skeleton width="100px" height="20px" margin="0 0 2px 0" />
        </PageName>
        <SponsoredMessage>{t("Sponsored", { lng: campaignLanguage })}</SponsoredMessage>
      </div>
    </PageHeaderWrapper>
  );
};

const PostEditorSkeleton = ({ mobile, campaignLanguage }) => {
  return (
    <PostEditorSkeletonWrapper mobile={mobile}>
      {mobile && <MobileTop src="/images/mobile-top.png" alt="" />}
      <div style={{ display: "flex" }}>
        {mobile && <MobileSide src="/images/mobile-left.png" alt="" />}
        <SkeletonEditorWrapper mobile={mobile}>
          <SkeletonEditor mobile={mobile}>
            <Header>
              <PageHeader campaignLanguage={campaignLanguage} />
            </Header>
            <EditorWrapper>
              <Skeleton width="464px" height="145px" />
            </EditorWrapper>
            <PhotoEditorWrapper>
              <Skeleton
                width={`${SKELETON_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].pictureWidth}px`}
                height="384px"
                borderRadius="0"
              />
            </PhotoEditorWrapper>
            <FooterWrapper>
              <FooterTextSections>
                <Skeleton width="100px" height="22px" margin="0 0 2px 0" />
                <Skeleton width="120px" height="22px" margin="0 0 2px 0" />
                <Skeleton width="100px" height="22px" margin="0 0 2px 0" />
              </FooterTextSections>
            </FooterWrapper>
          </SkeletonEditor>
        </SkeletonEditorWrapper>
      </div>
    </PostEditorSkeletonWrapper>
  );
};

export default PostEditorSkeleton;
